import { Controller } from 'stimulus'

// A "conditional" target (data-field, data-values="a,b") shows while that control holds one of the values,
// a ticked checkbox holding "1"; its inputs are disabled while hidden so they are not submitted.
// A "filtered" select (data-field) keeps only the options whose data-filter matches that control's value.
export default class extends Controller {
  static targets = ['conditional', 'filtered']

  connect() { this.refresh() }

  refresh() {
    this.filteredTargets.forEach((select) => this.filter(select))
    this.conditionalTargets.forEach((element) => this.reveal(element))
  }

  filter(select) {
    const value = this.value(select.dataset.field)
    Array.from(select.options).forEach((option) => {
      const match = !option.dataset.filter || option.dataset.filter === value
      option.hidden = !match
      option.disabled = !match
    })
    const selected = select.selectedOptions[0]
    if (!selected || selected.disabled) {
      const first = Array.from(select.options).find((option) => !option.disabled)
      select.value = first ? first.value : ''
    }
  }

  // Targets are walked in document order, so a hidden parent is settled before the conditionals inside it.
  reveal(element) {
    const shown = element.dataset.values.split(',').includes(this.value(element.dataset.field)) &&
      !element.parentElement.closest('.hidden')
    element.classList.toggle('hidden', !shown)
    element.querySelectorAll('input, select, textarea').forEach((input) => {
      input.disabled = !shown
      if (!shown && input.type === 'radio' && input.checked) this.checkFirst(input.name)
    })
  }

  checkFirst(name) {
    const radio = this.controls(name).find((control) => control.type === 'radio')
    if (radio) radio.checked = true
  }

  value(name) {
    const controls = this.controls(name)
    const choices = controls.filter((control) => control.type === 'radio' || control.type === 'checkbox')
    if (choices.length) return (choices.find((control) => control.checked) || { value: '' }).value
    return controls[0] ? controls[0].value : ''
  }

  controls(name) {
    return Array.from(this.element.querySelectorAll(`[name="${name}"]`))
      .filter((control) => !control.disabled && control.type !== 'hidden')
  }
}
